export default {
  seeUnarchivedCampaigns: 'Ver campañas sin archivar',
  seeArchivedCampaigns: 'Ver campañas archivadas',
  sendMassSms: 'Enviar SMS masivo',
  mustChargeBeforeSendingCampaigns: 'Debes recargar antes de enviar campañas',
  sendSmsCampaignFromFile: 'Enviar campaña SMS desde un archivo',
  createCampaign: 'Crear campaña',
  sendCampaignToDirectory: 'Enviar campaña a tu Directorio',
  forms: 'Formularios',
  unArchive: 'Desarchivar',
  archive: 'Archivar',
  loadingCampaigns: 'Cargando campañas',
  noCampaignsCreated: 'No has creado ninguna campaña',
  type: 'Tipo',
  status: 'Estado',
  campaignSuccessfullyArchived: 'Campaña archivada correctamente',
  sendCampaign: 'Enviar campaña',
  shippingDateAndTime: 'Fecha y hora de envío',
  scheduleCampaign: 'Programar campaña',
  campaignReadyAndWaitingToBeSent: 'Tu campaña está preparada y se encuentra en espera de ser enviada',
  schedule: 'Programar',
  export: 'Exportar',
  campaignStatus: 'Estado de la campaña',
  campaignScope: 'Alcance de la campaña',
  messagesToBeSent: 'Mensajes a enviar',
  thisValueCouldChange: 'Este valor puede cambiar',
  finalValue: 'Valor final',
  sendingDate: 'Fecha de envío',
  campaignProgress: 'Progreso de la campaña',
  moreCounters: 'Más contadores',
  lessCounters: 'Menos contadores',
  importingPeopleProgress: 'Progreso de la importación de personas',
  importedPeople: 'Personas importadas',
  peopleAmount: 'Total de personas',
  importingErrors: 'Errores de importación',
  sending: 'Enviando',
  sent: 'Enviada | Enviado | Enviados',
  onStandBy: 'En espera',
  onDraft: 'En borrador',
  scheduled: 'Programada',
  all: 'Todos',
  pending: 'Pendiente',
  deliveredToCarrier: 'Entregados al carrier',
  rejected: 'Rechazado | Rechazados',
  postponed: 'Aplazado | Aplazados',
  hardRebound: 'Rebote fuerte | Rebotes fuertes',
  softRebound: 'Rebote suave | Rebotes suaves',
  opened: 'Abierto | Abiertos',
  inSpam: 'En spam',
  terminated: 'Dado de baja | Dados de baja',
  inBlackList: 'En lista negra',
  inWhiteList: 'En lista blanca',
  messagePart: 'Parte de mensaje | Partes de mensaje',
  delivered: 'Entregado',
  importMorePeople: 'Importar mas personas',
  loadingUsers: 'Cargando usuarios',
  clicked: 'Clickeado',
  multiParts: 'Multiples partes',
  seeMessage: 'Ver mensaje',
  noUserDefinedMessage: 'El usuario no tiene un mensaje definido',
  youAreSeeingTheMessageOf: 'Estás viendo el mensaje de',
  nameOfTheMassSms: 'Nombre del SMS masivo',
  insertMassSmsKeyName: 'Ingresa un nombre para ayudar a recordar de qué se trata este SMS masivo',
  noFilePicked: 'No has seleccionado un archivo',
  downloadFormat: 'Descargar formato',
  prepareMassSms: 'Preparar SMS masivo',
  insertMassSmsName: 'Ingresa el nombre del SMS masivo',
  mustPickSmsFile: 'Debes seleccionar el archivo de los SMS',
  campaignSuccessfullyCreated: 'Campaña creada correctamente',
  campaignName: 'Nombre de la campaña',
  insertMassCampaignKeyName: 'Ingresa un nombre para ayudar a recordar de qué se trata esta campaña',
  campaignType: 'Tipo de campaña',
  pickCampaignType: 'Selecciona el tipo de campaña',
  writeYourMessageHere: 'Escribe aquí tu mensaje...',
  pickPeopleList: 'Selecciona una lista de personas',
  pickOrCreateListOfPeopleToCommunicateMessage: 'Selecciona la lista de personas a las que deseas comunicar tu mensaje o crea una lista nueva importandolos desde un archivo externo.',
  pickOrCreateTemplate: 'Selecciona en la lista tus plantillas guardadas o crear una desde cero',
  pickTemplate: 'Elige tu plantilla',
  allPeople: 'Todas las personas',
  waitWhileTheListGetsCreated: 'Espere mientras se crea la lista',
  noPeopleListPicked: 'No has seleccionado una lista de personas',
  addYourFirstCondition: 'Agrega tu primera condición',
  addAnotherCondition: 'Agrega otra condición',
  attributeCondition: 'Condición de Atributo',
  actionCondition: 'Condición de acción',
  segmentPeopleByAttributesAndActions: 'Puedes segmentar a las personas que interactuan con tu empresa, ya sea por sus atributos, o por acciones realizadas dentro de tu plataforma.',
  youAreAlmostDone: '¡Ya casi terminas!',
  yourMessageScope: 'Tu mensaje llegará a {numberOfPeople} personas',
  prepareCampaign: 'Preparar campaña',
  draft: 'Guardar',
  template: 'Plantilla',
  insertMessageSubject: 'Ingresa el asunto de tu mensaje',
  insertMessageHtml: 'Ingresa el html de tu mensaje',
  createHtmlTemplate: 'Crea tu plantilla',
  importPeople: 'Importar personas',
  insertCampaignName: 'Ingresa el nombre de la campaña',
  insertCampaignType: 'Ingresa el tipo de campaña',
  subject: 'Asunto',
  templates: 'Plantillas',
  allTemplates: 'Todas las plantillas',
  insertHtmlTemplate: 'Crear plantilla',
  previewTemplate: 'Previsualizar template',
  customize: 'Personalizar',
  from: 'Desde',
  to: 'Para',
  until: 'Hasta',
  attribute: 'Atributo',
  contains: 'Contiene',
  noContains: 'No contiene',
  is: 'es',
  isNot: 'No es',
  addANameToYourTemplate: 'Añade un nombre a tu template',
  templateName: 'Nombre del template',
  save: 'Guardar',
  /* Triggers */
  triggers: 'Disparadores',
  noTitle: 'Sin título',
  loadingTriggers: 'Cargando disparadores',
  noRegisteredTriggers: 'No hay Disparadores registrados',
  title: 'Título',
  executeTriggerWhenActionFire: 'Ejecutar disparador cuando sea una acción',
  customActionToFilter: 'Acción personalizada a filtrar',
  actionsToExecute: 'Acciones a ejecutar',
  emailBody: 'Cuerpo del email',
  smsBody: 'Cuerpo del SMS',
  postRequestData: 'Datos de la petición POST',
  saveTrigger: 'Guardar disparador',
  trigger: 'Disparador',
  new: 'Nuevo',
  edit: 'Editar',
  add: 'Agregar',
  triggerDetails: 'Detalles del disparador',
  triggerScope: 'Alcance del disparador',
  editTrigger: 'Edit trigger',
  createTrigger: 'Create trigger',
  triggerSuccessfullyCreated: 'Trigger creado exitosamente',
  triggerSuccessfullyUpdated: 'Trigger actualizado exitosamente',
  launchers: 'Lanzadores',
  actionType: 'Acción {action}',
  addNotification: 'Agregar notificación',
  notifications: 'Notificaciones',
  loadingNotifications: 'Cargando notificaciones',
  noNotificationsCreated: 'No hay notificaciones creadas',
  newNotification: 'Nueva notificación',
  notificationCreatedSuccessfully: 'Notificación creada correctamente',
  editNotification: 'Editar notificación',
  notificationEditedSuccessfully: 'Notificación editada correctamente',
  youDontHaveNotifications: 'No tienes notificaciones',
  invalidFileType: 'Tipo de archivo invalido',
  noDataFound: 'No se encontraron datos',
  clickOnYourFileTypeOrDragHere: 'Click en tu tipo de archivo o arrastralo aquí',
  filesSize: 'No se admiten archivos mayores a 5 Mbs o videos mayores a 16 mb',
  findQuickAnswer: 'Buscar respuesta rápida',
  noAnswerFound: 'No encontramos la respuesta que buscas',
  titleNewInformation: 'Titulo de la nueva información',
  waitingForAttention: 'En espera de atención',
  terminationReason: 'Razón de finalización',
  findTerminationReason: 'Buscar razón de terminación',
  nameless: 'Sin nombre',
  conversationClassification: 'Clasificación de conversaciones',
  withoutAdvisor: 'Sin asesor',
  you: 'Tú',
  agents: 'Agentes',
  advisors: 'Asesores',
  conversations: 'Conversaciones',
  host: 'Anfitrión',
  attended: 'Atendidas',
  noAttended: 'No atendidas',
  responseTime: 'Duración de la conversación',
  noAttendedConversations: 'Conversaciones no atendidas',
  attendedConversations: 'Conversaciones atendidas',
  totalConversations: 'Total conversaciones',
  lastMonth: 'Último mes',
  phone: 'Celular',
  organic: 'Orgánicas',
  conversationsPerChannel: 'Conversaciones por canal',
  createdPeople: 'Personas creadas',
  waitTime: 'Tiempo de espera',
  yesterday: 'Día anterior',
  withBot: 'Con bot',
  assignTaskAfterSettingJourney: 'Asignar tarea luego de asignar estado del Journey',
  pickAJourneyStatus: 'Selecciona el estado del Journey',
  journeys: 'Journeys',
  timeInMinutesToCreateTaskAfterSettingJourney: 'Tiempo en minutos para crear tarea luego de asignar Journey',
  untrainedQuestions: 'Preguntas no entrenadas',
  numberOfQuestions: 'Número de preguntas',
  serviceRating: 'Calificación de servicio',
  usersWhoGotProactivity: 'Usuarios a los que les llegó la proactividad',
  bot: 'Robot',
  questions: 'Preguntas',
  operator: 'Operador',
  time: 'Tiempo',
  attendedAndUnansweredConversations: 'Conversaciones atendidas y no atendidas',
  total: 'Total',
  pickExtraData: 'Selecciona un dato adicional',
  pickExtraDataFieldAndValue: 'Selecciona un dato adicional y escribe su valor',
  writeExtraDataValue: 'Escribe el valor de un dato adicional',
  termsAndConditions: 'Términos y condiciones',
  showTermsAndConditionsOfUse: 'Mostrar términos y condiciones de uso',
  termsAndConditionsLink: 'Enlace de términos y condiciones',
  campaignInformation: 'Información de la campaña',
  // Trigger to do list translations
  smsToUser: 'SMS al usuario',
  emailToUser: 'Email al usuario',
  postRequestToServer: 'Petición POST al servidor',
  createTaskForUser: 'Crear tarea al usuario',
  // Trigger action types translations
  ACTION_CUSTOM: 'Acción personalizada',
  ACTION_REGISTER_EMAIL: 'Al registrarse con Email',
  ACTION_REGISTER_PHONE: 'Al registrarse con teléfono',
  ACTION_REGISTER_VERIFIED: 'Al verificar registro',
  ACTION_REGISTER_EMAIL_RESEND: 'Al reenviar Email de registro',
  ACTION_REGISTER_SOCIAL: 'Al registrarse con redes sociales',
  ACTION_REGISTER_GOOGLE: 'Al registrarse con Google',
  ACTION_REGISTER_FACEBOOK: 'Al registrarse con Facebook',
  ACTION_REGISTER_SPOTIFY: 'Al registrarse con Spotify',
  ACTION_REGISTER_INSTAGRAM: 'Al registrarse con Instagram',
  ACTION_REGISTER_APPLEID: 'Al registrarse con AppleId',
  ACTION_REGISTER_EMAIL_FAIL: 'Cuando el registro con email falle',
  ACTION_REGISTER_PHONE_FAIL: 'Cuando el registro con teléfono falle',
  ACTION_LOGIN_EMAIL: 'Al iniciar sesión con email',
  ACTION_LOGIN_PHONE: 'Al iniciar sesión con teléfono',
  ACTION_LOGIN_SOCIAL: 'Al iniciar sesión con redes sociales',
  ACTION_LOGIN_GOOGLE: 'Al iniciar sesión con Google',
  ACTION_LOGIN_FACEBOOK: 'Al iniciar sesión con Facebook',
  ACTION_LOGIN_INSTAGRAM: 'Al iniciar sesión con Instagram',
  ACTION_LOGIN_SPOTIFY: 'Al iniciar sesión con Spotify',
  ACTION_LOGIN_APPLEID: 'Al iniciar sesión con AppleId',
  ACTION_LOGIN_MAIL_ONE_TIME_PASSWORD: 'Al iniciar sesión con email y one time password',
  ACTION_LOGIN_MAIL_ONE_TIME_PASSWORD_FAIL: 'Cuando iniciar sesión con email y one time password falle',
  ACTION_LOGIN_PHONE_ONE_TIME_PASSWORD: 'Al iniciar sesión con teléfono y one time password',
  ACTION_LOGIN_PHONE_ONE_TIME_PASSWORD_FAIL: 'Cuando iniciar sesión con teléfono y one time password falle',
  ACTION_LOGIN_EMAIL_FAIL: 'Cuando iniciar sesión con email falle',
  ACTION_LOGIN_EMAIL_FAIL_USER: 'Cuando el inicio de sesión del administrador con email falle',
  ACTION_LOGIN_EMAIL_FAIL_AUTHS: 'Cuando el inicio de sesión con email falle en la autenticación',
  ACTION_LOGIN_EMAIL_FAIL_WRONG_PSW: 'Cuando el inicio de sesión con email falle por contraseña equivocada',
  ACTION_LOGIN_PHONE_FAIL: 'Cuando el inicio de sesión con teléfono falle',
  ACTION_LOGIN_PHONE_FAIL_USER: 'Cuando el inicio de sesión del administrador con teléfono falle',
  ACTION_LOGIN_PHONE_FAIL_AUTHS: 'Cuando el inicio de sesión con teléfono falle en la autenticación',
  ACTION_LOGIN_PHONE_FAIL_WRONG_PSW: 'Cuando el inicio de sesión con teléfono falle por contraseña equivocada',
  ACTION_RESET_PASSWORD_PHONE: 'Al resetear contraseña con teléfono',
  ACTION_RESET_PASSWORD_EMAIL: 'Al resetear contraseña con email',
  ACTION_RESET_VALIDATION: 'Al validar el reset de contraseña',
  ACTION_RESET_OTP: 'Al resetear otp',
  ACTION_LOGOUT: 'Al cerrar sesión',
  ACTION_SUBMIT: 'Al enviar formulario',
  ACTION_SUBMIT_FILE: 'Al enviar archivo en formulario',
  ACTION_USER_IMAGE: 'Cuando la imagen del administrador cambie',
  ACTION_EVENT_PURCHASE: 'Al comprar ticket de evento',
  ACTION_EVENT_PURCHASE_CONFIRMATION: 'Al confirmarse la compra del ticket del evento',
  ACTION_USER_CHANGE: 'Cuando la información del administrador cambie',
  ACTION_ON_JOURNEY_SET: 'Al asignar Joruney',
  ACTION_ON_EXTRADATA_FIELD_CHANGE: 'Cuando el nombre de un extra data cambie',
  ACTION_ON_EXTRADATA_VALUE_CHANGE: 'Cuando el valor de un extra data cambie',
  attachFiles: 'Adjuntar archivos',
  attachFilesInCampaignDescription: `
  Con el fin de adjuntar archivos a tu campaña de Email,
  cada archivo que añadas debe pesar menos de 5 mb y el peso total de los
  archivos no debe superar los {size} {units}.
  `,
  sizeOfFileCantExceed: 'El tamaño máximo de cada archivo no puede exceder {size} {units}',
  filesTotalSizeMustBeSmallerThan: 'El tamaño total de tus archivos no puede exceder {size} {units}',
  attachedFiles: 'Archivos adjuntos',
  fileSuccessfullyDeleted: 'Archivo eliminado satisfactoriamente',
  fileWithSameNameAlreadyExists: 'Un archivo con el mismo nombre ya existe',
  filesSuccessfullyAttached: 'Archivo adjuntado satisfactoriamente'
}
